<template>
  <div class="block27">
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">
        <span class="arrow"></span>返回首页
      </router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <h2 class="title1">油门</h2>
      <div class="container-content">
        <p class="text_line">检查油门</p>
        <P>
          在发动机熄灭状态下，检查油门是否在所有转向位置都能顺畅从全开转至全闭，且自由行程正确无误。如果油门操作不顺畅、自动关闭或拉线破损，请交由本田特约维修店检修。
        </P>
        <table class="inside"><tr><td class="textLeft"><strong>油门转把凸缘处的自由行程：</strong><br>2至6mm</td></tr></table>
        <img src="./img/img1.jpg" width="100%" />
        <br />
        <br />
      </div>
      <div class="foot-btn">
        <div class="prev">
          <router-link to="/block26">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block28">下一页</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>